<div class="optimize mt-5 container" [id]="data?.id">
  <h3 class="text-center" *ngIf="data?.title">
    {{ data.title.split(" ")[0] }}
    <span> {{ data.title.split(" ").slice(1).join(" ") }}</span>
  </h3>

  <div
    class="row m-0 justify-content-center mt-2"
    *ngFor="let item of data.services; let i = index"
  >
    <div
      class="col-12 col-md-7 col-lg-8 my-auto px-4 order-2"
      [class.order-md-1]="i % 2 === 0"
      [class.order-md-2]="i % 2 !== 0"
    >
      <h1>{{ item.titleTr }}</h1>

      <h6 class="mb-4 description" [innerHTML]="item.summary"></h6>

      <button
        class="btn"
        [routerLink]="getDetailsUrl(item)"
        *ngIf="data.isDetails"
      >
        {{ "details" | translate }}
      </button>
    </div>

    <img
      class="col-12 col-md-5 col-lg-4 text-center p-0 img-fluid order-1"
      [src]="item.imageIconPath"
      alt=""
      [class.order-md-2]="i % 2 === 0"
      [class.order-md-1]="i % 2 !== 0"
    />
  </div>
</div>
